import { useLocation, useParams } from "react-router-dom";
import React, { useEffect } from 'react';
import UnAuthRoomCall from "./UnAuthRoomCall";
import AuthRoomCallLoading from "./AuthRoomCallLoading";
import Layout from "./Layout";
import { useDispatch } from "react-redux";
import { asyncCheckAuth, setAuth } from "../redux/auth";
import { AppDispatch } from "../store";
export default function AuthenticationRoomCall() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const roomID = query.get('id') ?? "";
    const pubkey = query.get('pubkey') ?? "";
    const message = query.get('message') ?? "";
    const signature = query.get('signature') ?? "";
    const isAudio =  query.get('isAudio') === "true" ? true : false;
    const isVideo = query.get('isVideo') === "true"? true : false;
    const [isAuth, setIsAuth] = React.useState(false);
    const [isAuthLoading, setIsAuthLoading] = React.useState(true);
    const arrRoomString = roomID.split(":")
    let groupID = "";
    let toPubkey = "";
    if (arrRoomString.length > 1) {
        if(arrRoomString[0]=== pubkey){
            toPubkey = arrRoomString[1];
        }else{
            toPubkey = arrRoomString[0];
        }
    }else{
        groupID = roomID
    }
    const authCallRequest: AuthCallRequest = {
        room_id: roomID,
        pubkey: pubkey,
        message: message,
        signature: signature,
        is_audio:isAudio,
        is_video:isVideo,
        to_pubkey:toPubkey,
        group_id:groupID
    }
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        // dispatch(setAuth(authCallRequest));

        dispatch(asyncCheckAuth(authCallRequest)).then((action) => {
            if (action.type === "auth/checkAuth/rejected") {
                setIsAuth(false);
            } else {
                setIsAuth(true);
            }
            setIsAuthLoading(false);
            dispatch(setAuth(authCallRequest));

        });
    }, [])
    return (
        <div>
            {isAuthLoading ? <AuthRoomCallLoading></AuthRoomCallLoading> : isAuth ? <Layout /> : <UnAuthRoomCall />}
        </div>
    );
}